import { List, Record } from 'immutable'
import moment from 'moment'
import { CalendarEventType } from './enums'

export interface ICalendarEventJS {
  id: string
  title: string
  description?: string
  allDay: boolean
  start: number
  type: CalendarEventType
  categories: string[]
}

export interface ICalendarEvent {
  readonly id: string
  readonly title: string
  readonly description?: string
  readonly allDay: boolean
  readonly start: Date
  readonly end: Date
  readonly type: CalendarEventType
  readonly categories: List<string>
}

const CalendarEventRecord = Record({
  allDay: false,
  categories: List<string>(),
  description: undefined,
  end: new Date(),
  id: '',
  start: new Date(),
  title: '',
  type: CalendarEventType.General,
})

export class CalendarEvent extends CalendarEventRecord
  implements ICalendarEvent {
  public static fromJS(initialState?: Partial<ICalendarEventJS>) {
    if (!initialState) {
      return new CalendarEvent()
    }

    const { categories, start, ...rest } = initialState

    return new CalendarEvent({
      categories: List(categories || []),
      end: start ? moment.unix(start).toDate() : new Date(),
      start: start ? moment.unix(start).toDate() : new Date(),
      ...rest,
    })
  }

  public readonly id: string
  public readonly title: string
  public readonly description?: string
  public readonly allDay: boolean
  public readonly start: Date
  public readonly end: Date
  public readonly type: CalendarEventType
  public readonly categories: List<string>

  constructor(props?: Partial<CalendarEvent>) {
    props ? super(props) : super()
  }
}
